<div class="em-c-btn__inner">
  <au-icon [icon]="icon" [size]="iconSize" [color]="iconColor" *ngIf="icon" class="em-c-btn__icon"
           [class.fitIcon-small]="fitIcon && iconSize === 'small'"
           [class.fitIcon-medium]="fitIcon && iconSize === 'medium'"
           [class.fitIcon-large]="fitIcon && iconSize === 'large'"></au-icon>
  <span class="em-c-btn__text" [ngClass]="buttonTextClass" *ngIf="text">{{ text }}<ng-content select="[text]"></ng-content></span>
  <ng-content></ng-content>
</div>